import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=ae2ebf10"
import script from "./modal.ts?vue&type=script&lang=js&external"
export * from "./modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2ebf10')) {
      api.createRecord('ae2ebf10', component.options)
    } else {
      api.reload('ae2ebf10', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=ae2ebf10", function () {
      api.rerender('ae2ebf10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/modal/modal.vue"
export default component.exports